import { store } from '@/store/store.js'

export const DEFAULT_LANGUAGE = store.state.locale
export const FALLBACK_LANGUAGE = store.state.locale
export const SUPPORTED_LANGUAGES = [ 'th',  'en']
